package br.com.vvrefeicoes.portal.feature.purchases

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.domain.model.PurchasesType
import com.composables.icons.lucide.Beef
import com.composables.icons.lucide.Carrot
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Milk
import com.composables.icons.lucide.PackagePlus
import com.composables.icons.lucide.Soup
import com.composables.icons.lucide.SprayCan
import com.composables.icons.lucide.Utensils
import com.composables.icons.lucide.Wheat
import org.jetbrains.compose.resources.StringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.compras_category_chinese
import portalvv.shared.generated.resources.compras_category_cleaning
import portalvv.shared.generated.resources.compras_category_dairy
import portalvv.shared.generated.resources.compras_category_disposables
import portalvv.shared.generated.resources.compras_category_extras
import portalvv.shared.generated.resources.compras_category_produce
import portalvv.shared.generated.resources.compras_category_proteins
import portalvv.shared.generated.resources.compras_category_staples

enum class PurchasesCategory(
    val type: PurchasesType?,
    val label: StringResource,
    val icon: ImageVector,
    val iconBackground: Color,
    val iconColor: Color,
) {
    Proteins(
        type = PurchasesType.PROTEINS,
        label = Res.string.compras_category_proteins,
        icon = Lucide.Beef,
        iconBackground = AppPalette.Error100,
        iconColor = AppPalette.Error900,
    ),
    Staples(
        type = PurchasesType.STAPLES,
        label = Res.string.compras_category_staples,
        icon = Lucide.Wheat,
        iconBackground = AppPalette.Warning100,
        iconColor = AppPalette.Warning900,
    ),
    Dairy(
        type = PurchasesType.DAIRY,
        label = Res.string.compras_category_dairy,
        icon = Lucide.Milk,
        iconBackground = AppPalette.Info100,
        iconColor = AppPalette.Info900,
    ),
    Produce(
        type = PurchasesType.PRODUCE,
        label = Res.string.compras_category_produce,
        icon = Lucide.Carrot,
        iconBackground = AppPalette.Success100,
        iconColor = AppPalette.Success900,
    ),
    Chinese(
        type = PurchasesType.CHINESE,
        label = Res.string.compras_category_chinese,
        icon = Lucide.Soup,
        iconBackground = Color(0xFFFFF0D6),
        iconColor = Color(0xFFD97706),
    ),
    Cleaning(
        type = PurchasesType.CLEANING,
        label = Res.string.compras_category_cleaning,
        icon = Lucide.SprayCan,
        iconBackground = AppPalette.Primary100,
        iconColor = AppPalette.Primary900,
    ),
    Disposables(
        type = PurchasesType.DISPOSABLES,
        label = Res.string.compras_category_disposables,
        icon = Lucide.Utensils,
        iconBackground = AppPalette.Neutral200,
        iconColor = AppPalette.Neutral900,
    ),
    Extras(
        type = null,
        label = Res.string.compras_category_extras,
        icon = Lucide.PackagePlus,
        iconBackground = AppPalette.Purple100,
        iconColor = AppPalette.Purple900,
    ),
}

sealed interface PurchasesSummaryValue {
    data class Amount(
        val cents: Long,
    ) : PurchasesSummaryValue

    data class Items(
        val items: Long,
    ) : PurchasesSummaryValue

    data object None : PurchasesSummaryValue
}

data class PurchasesSummaryItem(
    val title: StringResource,
    val icon: ImageVector,
    val iconBackground: Color,
    val iconColor: Color,
    val value: PurchasesSummaryValue,
    val onClick: (() -> Unit)? = null,
    val highlighted: Boolean = false,
)
